import styled from 'styled-components';

import { color, mediaQuery, fontWeight } from '../../services/settings.json';

export const Container = styled.div`
	background-color: ${({ bgcolor }) => (bgcolor)};
	overflow: hidden;
	border-radius: 8px;
	box-shadow: ${({ noshadow }) => (noshadow ? 'none' : `0 2px 2px ${color.shadow}`)};
	height: ${({ height }) => height};
	width: ${({ width }) => width};
	margin: ${({ margin }) => margin};
	padding: ${({ padding }) => padding};
	position: ${({ position }) => position};
	background-image: ${({ backgroundimage }) => `url("${backgroundimage}")`};
	background-position: center;
	background-size: cover;
	background-repeat: no-repeat;

	@media screen and (min-width: ${mediaQuery.desktop}px) {
		height: ${({ heightDesktop }) => heightDesktop};
	}
`;
export const Title = styled.div`
	padding: 14px 32px;
	display: flex;
	align-items: center;
	background-color: ${color.dark2};
	> span {
		margin-right: 15.07px;
		> svg {
			height: 19.87px;
			fill: #FFFFFF;
		}
	}
	> h5 {
		font-family: 'Poppins', sans-serif;
		font-weight: ${fontWeight.regular};
		color: ${color.light};
		line-height: 20px;
		font-size: 14px;
		margin: 0;
	}
`;
export const Content = styled.article`
	padding: ${({ padding }) => padding};
	display: ${({ display }) => display};
	justify-content: ${({ justifyContent }) => justifyContent};
	align-items: ${({ align }) => align};
`;
